import navSidebar from './reducers';

export default navSidebar;
